// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline___RhZw","title":"styles_title__5xi8k","subtitle":"styles_subtitle__HEesN"};